/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { CloudSearchResponse } from '../models/cloud-search-response';
import { mediaControllerCloudSearch } from '../fn/media/media-controller-cloud-search';
import { MediaControllerCloudSearch$Params } from '../fn/media/media-controller-cloud-search';
import { mediaControllerGetUrl } from '../fn/media/media-controller-get-url';
import { MediaControllerGetUrl$Params } from '../fn/media/media-controller-get-url';
import { MediaItemUrl } from '../models/media-item-url';

@Injectable({ providedIn: 'root' })
export class MediaService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `mediaControllerGetUrl()` */
  static readonly MediaControllerGetUrlPath = '/multimedia/url/{name}';

  /**
   * Genera l'URL per accedere al media.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mediaControllerGetUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaControllerGetUrl$Response(params: MediaControllerGetUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaItemUrl;
}>> {
    return mediaControllerGetUrl(this.http, this.rootUrl, params, context);
  }

  /**
   * Genera l'URL per accedere al media.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mediaControllerGetUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaControllerGetUrl(params: MediaControllerGetUrl$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MediaItemUrl;
}> {
    return this.mediaControllerGetUrl$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MediaItemUrl;
}>): BaseResponse & {
'data'?: MediaItemUrl;
} => r.body)
    );
  }

  /** Path part for operation `mediaControllerCloudSearch()` */
  static readonly MediaControllerCloudSearchPath = '/multimedia/unsplash/find';

  /**
   * Ricerca immagini su unsplash.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mediaControllerCloudSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaControllerCloudSearch$Response(params: MediaControllerCloudSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CloudSearchResponse;
}>> {
    return mediaControllerCloudSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * Ricerca immagini su unsplash.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mediaControllerCloudSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaControllerCloudSearch(params: MediaControllerCloudSearch$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CloudSearchResponse;
}> {
    return this.mediaControllerCloudSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CloudSearchResponse;
}>): BaseResponse & {
'data'?: CloudSearchResponse;
} => r.body)
    );
  }

}
